import React, { useState } from 'react';
import './ImageWithLoader.css';

function ImageWithLoader({ src, alt, className = '', ...props }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className={`image-loader-wrapper ${className}`}>
      {!loaded && !error && <div className="image-skeleton" />}
      {error ? (
        <div className="image-error">
          <i className="fas fa-image"></i>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          className={loaded ? 'image-loaded' : 'image-loading'}
          {...props}
        />
      )}
    </div>
  );
}

export default ImageWithLoader;
